import { WidgetWrapper } from '@agentselly/ui';
import { clsx } from 'clsx';
import { useState } from 'react';

interface Props {
  readonly questions: {
    readonly question: string;
    readonly answer: string;
    readonly link: string;
  }[];
}

export function PartnerFrequentlyAskedQuestionsWidget(props: Props) {
  const [
    selectedQuestion,
    setSelectedQuestion,
  ] = useState('');

  // TODO: Implement this

  return (
    <WidgetWrapper title="Häufige Fragen">
      <div className="flex flex-col gap-4">
        {props.questions?.map((entry) => (
          <div
            key={entry.question}
            className="flex flex-col gap-2 border border-gray-50 rounded-xl"
          >
            <h3
              className="cursor-pointer px-4 py-2 text-lg"
              onClick={() =>
                setSelectedQuestion(
                  selectedQuestion === entry.question ? '' : entry.question,
                )
              }
            >
              {entry.question}
              <span className="float-end">
                {selectedQuestion === entry.question ? '-' : '+'}
              </span>
            </h3>
            <div
              className={clsx(
                'flex flex-col gap-2 p-4 border-t border-gray-50',
                selectedQuestion === entry.question ? 'flex' : 'hidden',
              )}
            >
              <p>{entry.answer}</p>
              <a
                href={entry.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-400"
              >
                Mehr erfahren →
              </a>
            </div>
          </div>
        ))}
      </div>
    </WidgetWrapper>
  );
}
